import { render, staticRenderFns } from "./CareerFreeze.vue?vue&type=template&id=36fef174"
import script from "./CareerFreeze.vue?vue&type=script&lang=js"
export * from "./CareerFreeze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports